import {
  Grid,
  Typography,
  Button,
  Card,
  CardContent,
  SvgIcon,
} from '@mui/material';
import {AppliedTileProps, RECRUITER_ACTION_TEXT} from '../types';
import {Avatar} from '@jobseeker/lotus/components';
import {
  fetchJobDetails,
  fetchJobInsights,
} from '@jobseeker/common-core/reducers/job/thunkServices/jobdetail';
import type {JobDetail as JB} from '@jobseeker/common-core/stateModels/job/jobdetail.models';

import {useDispatch, useSelector} from 'react-redux';
import useValidateAuth from '@jobseeker/common-core/hooks/useValidateAuth';
import {handleTracking, openUrl} from '@jobseeker/common-core/utils';
import {useRouter} from 'next/router';
import {useEffect, useRef, useState} from 'react';
import {userService} from '@jobseeker/common-core/services';
import jobDetailService from '@jobseeker/common-core/services/jobdetail.service';
import ScheduledInterview from './ScheduledInterview';
import LockedStatus from './LockedStatus';
import {Tooltip} from '@jobseeker/lotus/elements';
import {useIsCustomWidth} from '@jobseeker/lotus/hooks';
import {JobdetailQr} from '@jobseeker/lotus/assets/images';

const AppliedTile = ({
  id,
  applicantId,
  applicationId,
  applicationDate,
  recruiterDetail,
  recruiterAction,
  jobDetail,
  followUp,
  views,
  app_count,
  unpublishInfo,
  confidential,
  app_status,
  recruiterActions,
  inviteStatus,
  lastActive,
  isPro,
  hasfollowup,
  interviewDate,
  interviewTime,
  slotId,
  calId,
  remSlots,

  setshowProMembershipPrompt,
  setShowFollowUpProMembershipPrompt,
  setInsightsbox,
  setShowStatusProMembershipPrompt,
}: AppliedTileProps) => {
  const loc = jobDetail.location.map(obj => {
    return obj.name;
  });

  const router = useRouter();
  const [followedUp, setFollowedUp] = useState(followUp?.status || false);
  const isMedium = useIsCustomWidth(1024);
  const dispatch =
    /* eslint-disable @typescript-eslint/no-explicit-any */ useDispatch<any>();
  // useValidateAuth(dispatch);
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);
  const textRef = useRef<HTMLAnchorElement>(null);
  function removeHtmlAndAppendRef(url: string) {
    // Remove ".html" at the end if present
    const cleanedUrl = url.endsWith('.html') ? url.slice(0, -5) : url;

    // Check if the URL already contains a query string
    if (cleanedUrl.includes('?')) {
      return `${cleanedUrl}&ref=apj`;
    }

    // If no query string is present, append `?ref=akf`
    return `${cleanedUrl}?ref=apj`;
  }

  const jobUrl = removeHtmlAndAppendRef(jobDetail.jobUrl);
  useEffect(() => {
    if (textRef.current) {
      const element = textRef.current;

      // Calculate if the content overflows beyond two lines
      const hasOverflow = element.scrollHeight > element.clientHeight;
      setIsTooltipVisible(hasOverflow);
    }
  }, [jobDetail.title]);

  const handleClick = (event: React.MouseEvent) => {
    event.preventDefault();

    // Check if any text is selected
    const selectedText = window.getSelection()?.toString();
    if (selectedText) {
      // If text is selected, don't trigger the click action
      return;
    }

    // Proceed with the click action if no text is selected
    openUrl(jobUrl, '_blank', 'noopener,noreferrer');
  };
  const jd: JB = useSelector((state: any) => state.jobDetail);

  useEffect(() => {
    if (jd && jd.id === jobDetail.id) {
      console.log('jobDetails', jd);
      setInsightsbox(true);
    }
  }, [jd, jobDetail.id]);
  const openInsightsDialog = async () => {
    if (!isPro) {
      setshowProMembershipPrompt(true);
    } else {
      try {
        await dispatch(fetchJobDetails({jobId: String(jobDetail.id)}));
        await dispatch(
          fetchJobInsights({
            userId: String(applicantId),
            jobId: String(jobDetail.id),
          })
        );

        handleTracking('prostatusview', {
          event_category: 'insightpopup',
          UserId: sessionStorage.getItem('userId') || 'NA',
          Device: sessionStorage.getItem('device') || 'desktop',
          Device_Type: sessionStorage.getItem('deviceType') || 'web',
          Status: sessionStorage.getItem('status') || 'LoggedOut',
          Origin: router.pathname,
          Type: 'view',
          CompanyId: recruiterDetail.organisationId,
        });
      } catch (error) {
        console.error('Error fetching job insights:', error);
      }
    }
  };

  const handleJobFollowup = () => {
    if (!isPro) {
      setShowFollowUpProMembershipPrompt(true);
    } else {
      handleTracking('ClickFollowUp', {
        event_category: 'Job',
        Origin: router.pathname,
        Source: 'JobDescription',
        CategoryId: jobDetail.categoryId,
        JobId: jobDetail.id,
        RecruiterId: recruiterDetail?.recruiterId,
        UserId: sessionStorage.getItem('userId') || 'NA',
        Device: sessionStorage.getItem('device') || 'desktop',
        Device_Type: sessionStorage.getItem('deviceType') || 'web',
        Status: sessionStorage.getItem('status') || 'LoggedOut',
      });

      (async () => {
        try {
          const followUp = await jobDetailService.doFollowUp({
            jobId: jobDetail.id,
          });
          if (typeof followUp === 'boolean') {
            // await userService.updateFollowUp();
            setFollowedUp(followUp);
          }
        } catch (error: unknown) {
          console.log('🚀 ~ file: index.tsx:298 ~ error:', error);
        }
      })();
    }
  };

  const initiateChat = () => {
    if (!(window as any).chatObject) return;

    (window as any).chatObject.initiateChat({
      type: 'j', // r- recruiter, j- jobseeker
      userId: applicantId,
      recipientId: recruiterDetail.recruiterId,
      tokenName: `${process.env.NEXT_PUBLIC_APP_NAME?.toUpperCase()}_CK1`,
    });
    console.log(applicantId, recruiterDetail.recruiterId);
  };
  const formatPostedTime = (createdTime: string | number): string => {
    const currentTime = new Date();
    const jobTime = new Date(createdTime);
    const differenceInMilliseconds = currentTime.getTime() - jobTime.getTime();

    const differenceInDays = Math.floor(
      differenceInMilliseconds / (1000 * 60 * 60 * 24)
    );
    const differenceInWeeks = Math.floor(differenceInDays / 7);
    const differenceInMonths = Math.floor(differenceInDays / 30); // Approximate: 1 month = 30 days
    const differenceInYears = Math.floor(differenceInDays / 365); // Approximate: 1 year = 365 days

    if (differenceInYears >= 1) {
      return `Posted ${differenceInYears} year${
        differenceInYears > 1 ? 's' : ''
      } ago`;
    }

    if (differenceInMonths >= 1) {
      return `Posted ${differenceInMonths} month${
        differenceInMonths > 1 ? 's' : ''
      } ago`;
    }

    if (differenceInWeeks >= 1) {
      return `Posted ${differenceInWeeks} week${
        differenceInWeeks > 1 ? 's' : ''
      } ago`;
    }

    return differenceInDays === 0
      ? 'Posted today'
      : `Posted ${differenceInDays} day${differenceInDays > 1 ? 's' : ''} ago`;
  };
  return (
    <Card
      sx={{
        margin: 0,
        boxShadow: 0,
        marginLeft: 2,
        marginRight: 2,
        paddingTop: 0,
        paddingBottom: 0,
        marginBottom: 2,
        marginTop: 1,
        borderRadius: 2,
        border: 'solid 1px',
        borderColor: '#F3F7FA',
      }}
    >
      {/* First Content Section */}
      <CardContent
        sx={{
          backgroundColor: '#F3F7FA',
          paddingBottom: 0,
          marginTop: 0,
          paddingTop: 0,
          marginLeft: 0,
          paddingLeft: 0,
          marginRight: 0,
          paddingRight: 0,
          borderRadius: 1,
        }}
      >
        <Grid
          container
          direction="row"
          spacing={0}
          paddingLeft={0}
          marginLeft={0}
          paddingRight={0}
          marginRight={0}
          data-testid="applied-jobs-card-title"
        >
          {/* Date */}
          <Grid
            item
            paddingLeft={0}
            marginTop={1.5}
            xl={1.466}
            lg={1.65}
            xxs={1.63}
          >
            <Typography
              variant="body2"
              color="textPrimary"
              sx={{
                marginLeft: 1,
                height: 16,
                cursor: 'default',
                paddingLeft: 0,
                paddingTop: 0,
                fontSize: 12,
                fontWeight: 500,
                fontStyle: 'normal',
              }}
            >
              {' '}
              {/* Match size and color */}
              {new Date(applicationDate)
                .toLocaleDateString('en-GB')
                .split('/')
                .join('-')}
            </Typography>
          </Grid>

          {/* Title and Subtext */}
          <Grid
            item
            marginLeft={0}
            marginTop={1.5}
            xl={3.18}
            lg={2.88}
            xxs={3.38}
          >
            {isTooltipVisible ? (
              <Tooltip arrow title={jobDetail.title}>
                <Typography
                  variant="body2"
                  component="a"
                  href={jobUrl}
                  ref={textRef}
                  sx={{
                    cursor: 'pointer',
                    textDecoration: 'none',
                    color: '#333',
                    paddingTop: 0,
                    paddingBottom: 0,
                    marginBottom: 0,
                    maxHeight: 40,

                    fontSize: 12,
                    fontWeight: 500,
                    fontStyle: 'normal',
                    '&:hover': {
                      backgroundColor: 'transparent',
                      textDecoration: 'none',
                    },
                    display: '-webkit-box',
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    WebkitLineClamp: 2,
                    textOverflow: 'ellipsis',
                    whiteSpace: 'normal',
                  }}
                  onClick={handleClick}
                >
                  {`${jobDetail.title.replace(/\(.*?\)/g, '').trim()}`}
                </Typography>
              </Tooltip>
            ) : (
              <Typography
                variant="body2"
                ref={textRef}
                component="a"
                href={jobUrl}
                sx={{
                  cursor: 'pointer',
                  color: '#333',
                  textDecoration: 'none',

                  paddingTop: 0,
                  paddingBottom: 0,
                  marginBottom: 0,
                  maxHeight: 40,

                  fontSize: 12,
                  fontWeight: 500,
                  fontStyle: 'normal',
                  '&:hover': {
                    backgroundColor: 'transparent',
                    textDecoration: 'none',
                  },
                  display: '-webkit-box',
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                  WebkitLineClamp: 2,
                  textOverflow: 'ellipsis',
                  whiteSpace: 'normal',
                }}
                onClick={event => {
                  event.preventDefault();
                  openUrl(jobUrl, '_blank', 'noopener,noreferrer');
                }}
              >
                {`${jobDetail.title.replace(/\(.*?\)/g, '').trim()}`}
              </Typography>
            )}

            {loc.length < 5 ? (
              <Typography
                variant="body2"
                sx={{
                  marginTop: 0.25,
                  paddingTop: 0,
                  fontSize: 10,
                  marginBottom: 1.5,
                  cursor: 'default',
                  fontWeight: 400,
                  fontStyle: 'normal',
                  color: '#7E7E7E',
                }}
              >
                {`${jobDetail.min}-${jobDetail.max} yrs`}{' '}
                <span style={{marginLeft: 1, marginRight: 1}}>&#9679;</span>{' '}
                {loc.join(', ')}
              </Typography>
            ) : (
              <Typography
                variant="body2"
                sx={{
                  marginTop: 0.25,
                  paddingTop: 0,
                  fontSize: 10,
                  marginBottom: 1.5,
                  fontWeight: 400,
                  fontStyle: 'normal',
                  cursor: 'default',
                  color: '#7E7E7E',
                }}
              >
                {`${jobDetail.min}-${jobDetail.max} yrs`} <span>&#9679;</span>{' '}
                {loc.slice(0, 3).join(', ')}{' '}
                {loc.length > 3 && (
                  <Tooltip arrow title={loc.join(', ')}>
                    <Typography
                      variant="body2"
                      component="span"
                      sx={{
                        display: 'inline',
                        fontSize: 10,
                        fontWeight: 400,
                        color: '#49966E',
                        cursor: 'pointer',
                      }}
                    >
                      +{loc.length - 3} more
                    </Typography>
                  </Tooltip>
                )}
              </Typography>
            )}
          </Grid>

          {/* Views */}
          <Grid
            item
            marginLeft={{xl: 5.125, lg: 6.5, xxs: 4}}
            marginTop={1.5}
            lg={0.613}
            xxs={0.68}
          >
            <Typography
              variant="body2"
              sx={{
                height: 18,
                cursor: 'default',
                marginTop: 0,
                paddingTop: 0,
                fontSize: 14,
                fontWeight: 500,
                fontStyle: 'normal',
              }}
            >
              {views?.toString()}
            </Typography>
          </Grid>

          {/* Applications */}
          <Grid
            item
            marginLeft={0}
            marginTop={1.5}
            xl={1.03}
            lg={1.1}
            xxs={1.27}
          >
            <Typography
              variant="body2"
              sx={{
                height: 18,
                cursor: 'default',
                marginTop: 0,
                paddingTop: 0,
                fontSize: 14,
                fontWeight: 500,
                fontStyle: 'normal',
              }}
            >
              {app_count?.toString()}
            </Typography>
          </Grid>

          {/* Actions */}
          <Grid
            item
            marginLeft={0}
            marginTop={1.5}
            xl={1.94}
            lg={1.87}
            xxs={1.04}
          >
            <Typography
              variant="body2"
              sx={{
                height: 18,
                cursor: 'default',
                marginTop: 0,
                paddingTop: 0,
                fontSize: 14,
                fontWeight: 500,
                fontStyle: 'normal',
              }}
            >
              {recruiterActions?.toString()}
            </Typography>
          </Grid>

          {/* Status */}
          <Grid
            item
            marginLeft={0}
            marginTop={1.5}
            xl={2.1}
            lg={1.86}
            xxs={2.03}
          >
            {isPro || RECRUITER_ACTION_TEXT[app_status] === 'APPLIED/SENT' ? (
              <Typography
                variant="body2"
                sx={{
                  height: 18,
                  cursor: 'default',
                  marginTop: 0,
                  paddingTop: 0,
                  fontSize: 14,
                  fontWeight: 600,
                  fontStyle: 'normal',
                  color:
                    RECRUITER_ACTION_TEXT[app_status] === 'APPLIED/SENT'
                      ? '#333'
                      : RECRUITER_ACTION_TEXT[app_status] === 'NOT SUITABLE'
                      ? '#7E7E7E'
                      : '#49966E',
                }}
              >
                {RECRUITER_ACTION_TEXT[app_status]}
              </Typography>
            ) : (
              <LockedStatus
                setShowStatusProMembershipPrompt={
                  setShowStatusProMembershipPrompt
                }
              />
            )}
          </Grid>

          {/* Follow Up Button */}
          <Grid
            item
            marginTop={1.5}
            marginLeft={0}
            sx={{display: 'flex', justifyContent: 'flex-end'}}
          >
            {isPro && !hasfollowup ? (
              <Tooltip
                arrow
                title="You have 0 follow-ups left. You get one follow-up every Thursday"
                disableInteractive
              >
                <span>
                  <Button
                    disabled={
                      followedUp ||
                      (isPro && !hasfollowup) ||
                      (app_status > 0 && isPro == true)
                    }
                    onClick={handleJobFollowup}
                    variant="outlined"
                    color="primary"
                    sx={{
                      borderRadius: '32px',
                      width: 112,

                      fontSize: 12,
                      textAlign: 'center',
                      whiteSpace: 'nowrap',
                      padding: '8px 27px',

                      minWidth: 'auto',
                      boxShadow: 3,
                      height: 32,
                      '&:hover': {
                        backgroundColor: 'transparent',
                        textDecoration: 'none',
                      },
                      '&:focus': {
                        backgroundColor: 'transparent',
                      },
                      '&:active': {
                        backgroundColor: 'transparent',
                      },
                    }}
                  >
                    {followedUp ? 'Followed Up' : 'Follow Up'}
                  </Button>
                </span>
              </Tooltip>
            ) : (
              <Button
                disabled={
                  followedUp ||
                  (isPro && !hasfollowup) ||
                  (app_status > 0 && isPro == true)
                }
                onClick={handleJobFollowup}
                variant="outlined"
                color="primary"
                sx={{
                  borderRadius: '32px',
                  width: 112,

                  fontSize: 12,
                  textAlign: 'center',
                  whiteSpace: 'nowrap',
                  padding: '8px 27px',

                  minWidth: 'auto',
                  boxShadow: 3,
                  height: 32,
                  '&:hover': {
                    backgroundColor: 'transparent',
                    textDecoration: 'none',
                  },
                  '&:focus': {
                    backgroundColor: 'transparent',
                  },
                  '&:active': {
                    backgroundColor: 'transparent',
                  },
                }}
              >
                {followedUp ? 'Followed Up' : 'Follow Up'}
              </Button>
            )}
          </Grid>
        </Grid>
      </CardContent>

      {/* Second Content Section */}
      <CardContent
        sx={{
          paddingBottom: '0px !important',
          paddingTop: 0,
          margin: 0,
          paddingLeft: 0,
          paddingRight: 0,
          borderRadius: 1,
        }}
      >
        <Grid
          container
          direction="row"
          spacing={0}
          paddingLeft={0}
          marginLeft={0}
          paddingRight={0}
          marginRight={0}
          paddingBottom={0}
        >
          <Grid
            item
            marginLeft={1}
            display="flex"
            alignItems="center"
            paddingBottom={0}
            marginBottom={2.5}
            marginTop={2.5}
          >
            <Avatar
              onClick={
                confidential
                  ? () => {}
                  : () => {
                      openUrl(
                        recruiterDetail.profileUrl,
                        '_blank',
                        'noopener,noreferrer'
                      );
                    }
              }
              sx={{
                cursor: confidential ? 'default' : 'pointer',
                height: 54,
                width: 54,
              }}
              imgUrl={confidential ? '' : recruiterDetail.pictureLink}
            />
          </Grid>

          {/* Title and Subtext */}
          <Grid
            item
            marginLeft={{xl: 13.375, lg: 13.25, xxs: 8.625}}
            paddingBottom={0}
            marginTop={2.125}
            xl={3.18}
            lg={2.88}
            xxs={3.38}
            data-testid="applied-jobs-title-posted-by"
          >
            <Typography
              variant="body2"
              sx={{
                paddingTop: 0,
                paddingBottom: 0,
                fontSize: 12,
                cursor: 'default',
                fontWeight: 400,
                fontStyle: 'normal',
              }}
            >
              Posted By:&nbsp;
              <Typography
                component="a"
                href={confidential ? '' : recruiterDetail.profileUrl}
                sx={{
                  paddingTop: 0,
                  paddingBottom: 0,
                  marginBottom: 0,
                  fontSize: 12,
                  fontWeight: 500,
                  fontStyle: 'normal',
                  cursor: confidential ? 'default' : 'pointer',
                  textDecoration: 'none',
                  '&:hover': {
                    textDecoration: 'none',
                  },
                }}
                onClick={
                  confidential
                    ? event => {
                        event.preventDefault();
                      }
                    : event => {
                        event.preventDefault();
                        openUrl(
                          recruiterDetail.profileUrl,
                          '_blank',
                          'noopener,noreferrer'
                        );
                      }
                }
                color="primary"
              >
                {confidential ? 'Verified Recruiter' : recruiterDetail.name}
              </Typography>
            </Typography>
            {!confidential && (
              <Typography
                variant="body2"
                sx={{
                  paddingTop: '0px',
                  paddingBottom: 0,
                  marginBottom: 0,
                  cursor: 'default',
                  fontSize: 12,
                  fontWeight: 400,
                  fontStyle: 'normal',
                  display: '-webkit-box',
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                  WebkitLineClamp: 2,
                  textOverflow: 'ellipsis',
                  whiteSpace: 'normal',
                }}
              >
                {`${recruiterDetail.designation} at ${recruiterDetail.organisationName}`}
              </Typography>
            )}
            {!confidential && (
              <Typography
                variant="body2"
                sx={{
                  visibility: lastActive ? 'visible' : 'hidden',
                  marginTop: 0.25,
                  paddingTop: 0,
                  marginBottom: 2,
                  fontSize: 12,
                  cursor: 'default',
                  fontWeight: 400,
                  fontStyle: 'normal',
                  color: '#7E7E7E',
                }}
              >
                Last Active:{' '}
                {lastActive && lastActive?.lastActiveDate
                  ? !isNaN(new Date(lastActive.lastActiveDate).getTime())
                    ? new Date(lastActive.lastActiveDate).toLocaleDateString(
                        'en-GB',
                        {
                          day: '2-digit',
                          month: 'long',
                          year: 'numeric',
                        }
                      )
                    : lastActive.lastActiveDate
                  : ''}
              </Typography>
            )}
          </Grid>
          <Grid
            item
            marginLeft={{xl: 5.125, lg: 6.5, xxs: 4}}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              marginTop: 2.875,
              paddingBottom: 0,
            }}
            xl={3.58}
            lg={3.588}
            xxs={4.22}
          >
            {unpublishInfo &&
            unpublishInfo?.unpublishedDate &&
            unpublishInfo?.unpublishedDate > 1 ? (
              <Typography
                variant="body2"
                sx={{
                  height: 32,
                  cursor: 'default',
                  marginTop: 0,
                  paddingTop: 0,
                  fontSize: 12,
                  fontWeight: 500,
                  fontStyle: 'normal',
                  color: '#7E7E7E',
                }}
              >
                This job was unpublished on{' '}
                {String(
                  new Date(unpublishInfo.unpublishedDate).getDate()
                ).padStart(2, '0')}
                /
                {String(
                  new Date(unpublishInfo.unpublishedDate).getMonth() + 1
                ).padStart(2, '0')}
                /{new Date(unpublishInfo.unpublishedDate).getFullYear()}
                <br></br> Reason: {unpublishInfo.unpublishReason}
              </Typography>
            ) : (
              <></>
            )}
          </Grid>

          {!isMedium ||
          !(
            unpublishInfo &&
            unpublishInfo?.unpublishedDate &&
            unpublishInfo?.unpublishedDate > 1
          ) ? (
            <Grid
              item
              marginLeft={{lg: 0, xxs: -12.125}}
              // marginTop={2}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                paddingBottom: 0,
                justifyContent: 'center',
              }}
              xl={2.1}
              lg={1.85}
              xxs={2.03}
            >
              {inviteStatus ? (
                interviewDate &&
                interviewTime &&
                new Date(
                  new Date(interviewDate).setHours(
                    parseInt(interviewTime.slice(0, 2)),
                    parseInt(interviewTime.slice(2))
                  ) +
                    30 * 60 * 1000
                ) < new Date() ? (
                  <></>
                ) : (
                  <ScheduledInterview
                    slotId={slotId}
                    calId={calId}
                    remSlots={remSlots}
                    date={
                      interviewDate && interviewTime && inviteStatus > 1
                        ? (() => {
                            const dateObj = new Date(interviewDate);
                            dateObj.setHours(
                              parseInt(interviewTime.slice(0, 2)),
                              parseInt(interviewTime.slice(2))
                            );

                            return dateObj
                              .toLocaleString('en-GB', {
                                day: '2-digit',
                                month: 'short',
                                year: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit',
                                hour12: true, // Use 24-hour format
                              })
                              .replace('at', ',')
                              .replace('am', 'AM')
                              .replace('pm', 'PM');
                          })()
                        : ''
                    }
                  />
                )
              ) : (
                <></>
              )}
              {isPro &&
              !confidential &&
              (app_status == 1 || (inviteStatus && app_status > 0)) &&
              !(
                unpublishInfo &&
                unpublishInfo?.unpublishedDate &&
                unpublishInfo?.unpublishedDate > 1
              ) ? (
                <Typography
                  onClick={initiateChat}
                  component="span"
                  sx={{
                    cursor: 'pointer',
                    fontSize: 12,
                    fontWeight: 500,
                    letterSpacing: '0.48px',
                    color: '#49966E',
                    verticalAlign: 'super',
                    marginBottom: 0,
                  }}
                >
                  Chat with Recruiter
                </Typography>
              ) : (
                <></>
              )}
            </Grid>
          ) : (
            <></>
          )}

          <Grid
            item
            marginLeft={0}
            sx={{
              alignItems: 'center',
              display: 'flex',
              flexDirection: 'column',
              // marginTop: 3.375,
              justifyContent: 'center',
              paddingBottom: 0,
            }}
          >
            <Button
              onClick={openInsightsDialog}
              variant="text"
              color="primary"
              sx={{
                textTransform: 'none',
                padding: 0,
                fontSize: 12,
                width: 80,
                border: 'none',
                boxShadow: 'none',
                whiteSpace: 'nowrap',
                '&:hover': {
                  backgroundColor: 'transparent',
                  textDecoration: 'none',
                },
                '&:focus': {
                  backgroundColor: 'transparent',
                  outline: 'none',
                },
                '&:active': {
                  backgroundColor: 'transparent',
                  outline: 'none',
                },
              }}
            >
              View Insights
            </Button>
            <Typography
              variant="caption"
              color="textSecondary"
              sx={{
                width: 112,
                marginTop: 0.25,
                fontSize: 10,
                whiteSpace: 'nowrap',
                textAlign: 'center',
              }}
            >
              {formatPostedTime(jobDetail.createdTime)}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default AppliedTile;
